module.exports = __webpack_public_path__ + "img/ltkmens-1x.d947230.jpg";